export const configs = {
  primaryColor: '#0fe4b9'
};
